export default "__VITE_ASSET__EYHPbmre__"